<template>
  <div class="welcome">
    <mdb-container fluid>
      <mdb-row style="height: 100vh" class>
        <mdb-col xl="4" class="bg-london-2"></mdb-col>
        <mdb-col xl="8" class="flex-center">
          <mdb-row class="flex-center column">
            <mdb-col
              sm="12"
              lg="12"
              xl="11"
              class="mx-auto d-flex justify-content-between"
            >
              <img src="../assets/Exsellance_Logo.png" class="ex-logo" />
              <router-link to="/login" class="ml-auto">Login</router-link>
            </mdb-col>
            <mdb-col sm="12" lg="12" xl="11" class="mx-auto">
              <h1 class="mb-2">Sales Learning Platform</h1>
              <p class="mb-5">
                Tailored for the start-ups and small businesses community
              </p>
              <!-- <h6 class="uppercase strong">What do you get?</h6> -->
              <mdb-row class="d-flex">
                <mdb-col sm="12" md="4" class="pb-4">
                  <mdb-card class="top-bar-blue h-100 mb-5">
                    <mdb-card-body>
                      <h5 class="mb-3">50+ sales videos</h5>
                      <ul>
                        <li>
                          <mdb-icon icon="check text-blue" />How to find clients
                        </li>
                        <li>
                          <mdb-icon icon="check text-blue" />How to sell and win
                        </li>
                        <li>
                          <mdb-icon icon="check text-blue" />How to sell more
                        </li>
                      </ul>
                    </mdb-card-body>
                  </mdb-card>
                </mdb-col>
                <mdb-col sm="12" md="4" class="pb-4">
                  <mdb-card class="top-bar-yellow h-100">
                    <mdb-card-body>
                      <h5 class="mb-3">Podcasts</h5>
                      <ul>
                        <li>
                          <mdb-icon icon="check text-yellow" />How to Pitch to
                          Retail Buyers (Paul Durrant)
                        </li>
                        <li>
                          <mdb-icon icon="check text-yellow" />How to sell to
                          NHS (CIO of NHS)
                        </li>
                        <li>
                          <mdb-icon icon="check text-yellow" />How to be
                          resilient (expert author)
                        </li>
                        <li>
                          <mdb-icon icon="check text-yellow" />Accountant views
                          on pricing and scaling
                        </li>
                      </ul>
                    </mdb-card-body>
                  </mdb-card>
                </mdb-col>
                <mdb-col sm="12" md="4" class="pb-4">
                  <mdb-card class="top-bar-purple h-100">
                    <mdb-card-body>
                      <h5 class="mb-3">Community</h5>
                      <ul>
                        <li>
                          <mdb-icon icon="check text-purple" />Platform to ask
                          and solve sales-related questions
                        </li>
                      </ul>
                      <h5 class="mb-3">10 critical skills</h5>
                      <ul>
                        <li>
                          <mdb-icon icon="check text-purple" />With personalized
                          learning recommendation
                        </li>
                      </ul>
                    </mdb-card-body>
                  </mdb-card>
                </mdb-col>
              </mdb-row>

              <mdb-row
                class="mt-5 d-flex horizontal-lines justify-content-between flex-center"
              >
                <mdb-col sm="12" md="3" class="text-center py-3">
                  <img
                    src="/img/Enterprise-Nation@2x.png"
                    class="en-nat-logo"
                  />
                </mdb-col>
                <mdb-col sm="12" md="3" class="text-center py-3">
                  <p class>
                    Exclusive Enterprise Nation Offer:
                    <span class="strong">
                      FREE ACCESS until 31st December 2020
                    </span>
                  </p>
                  <p></p>
                </mdb-col>
                <mdb-col sm="12" md="3" class="text-center py-3">
                  <router-link to="/register">
                    <mdb-btn color="primary" class="ml-0" rounded
                      >Access now</mdb-btn
                    >
                  </router-link>
                </mdb-col>
              </mdb-row>
            </mdb-col>

            <mdb-col sm="12" lg="12" xl="11" class="mx-auto">
              <p>Copyright © Exsellance 2020</p>
            </mdb-col>
          </mdb-row>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </div>
</template>
<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbInput,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbIcon
} from "mdbvue";

import firebase from "firebase";
import { statsMixin } from "../mixins/StatsMixin";
import { store } from "../store";

export default {
  name: "register",
  mixins: [statsMixin],
  data() {
    return {
      email: "",
      password: "",
      validationMessage: "",
      showModal: false,
      showWarning: false,
      accepted: false
    };
  },
  methods: {
    mthInitLocalstoreData() {
      this.$store.commit("setAssessmentIdParam", null);
      this.$store.commit("setUserhasfilledhisassessment", false);
      this.$store.commit("setIamtheboss", null);
      this.$store.commit("setAvatarurl", "");
      this.$store.commit("setNickname", "");
    },
    mthStatsIncrementNewUsers() {
      this.mthMixinStatsIncrementNewUsers();
    },
    mthFillProfileData(user) {
      //console.log("mthFillProfileData: user is ");

      //console.log(user);

      firebase
        .firestore()
        .collection("usersProfiles")
        .doc(this.email)
        .set({
          joinedDate: new Date()
        });
    },
    signup: function() {
      //signup button

      if (this.accepted === true) {
        var self = this;

        firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password)
          .then(
            function(user) {
              self.validationMessage = "Your account has been created.";

              self.mthFillProfileData(user);

              //self.$router.replace("/");
            },
            function(err) {
              self.validationMessage = err.message;
              alert(err);
            }
          );

        this.mthStatsIncrementNewUsers();

        this.mthInitLocalstoreData(); //clear existing values from previous user
      } else {
        this.showWarning = true;
      }
    }
  },
  created() {
    firebase.auth().onAuthStateChanged(user => {
      //console.log("onAuthStateChanged fired!");
      if (user) {
        this.$router.replace("/");
      }
    });
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbInput,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbIcon
  }
};
</script>

<style></style>
